module.exports = __webpack_public_path__ + "img/101-ei-02.prt.6c07971d.jpg";